/* Ganga V2 · colección y búsqueda (V2-09 y V2-17)
   - <gs-col-ver-mas>: "Ver más productos" de a 24, en lugar del scroll infinito
     (que hacía saltar la página y trababa Safari). Trae la página siguiente por section_id
     y suma las tarjetas abajo. Si una tanda vuelve vacía (todo de temporada), sigue sola
     con la próxima, hasta 3 veces. La tanda se pre-carga cuando el botón se acerca a la pantalla
     y, si al tocar todavía no llegó, se ponen lugares reservados en el acto (sin salto de página).
   - Ordenar: cambia el texto visible al toque. Si la página no tiene formulario de filtros
     (el tema ordena por AJAX con ese formulario), recarga con sort_by.
   - Al filtrar u ordenar sin recargar (assets/facets.js), el tema solo redibuja la grilla y los filtros: acá se
     redibujan también el título de la colección (#GsColCab, en todos sale del precio y del orden) y la fila de
     precio de un toque (#GsColPrecio), con el HTML que ya trajo el tema. Y la pestaña lleva el mismo título.
     El chip del header que marca la página (aria-current) se vuelve a elegir con la URL nueva, con las mismas
     reglas que sections/gs-chips.liquid (en todos: precio, si no orden; en las demás: con o sin precio; en la
     búsqueda: el término). */
(function () {
  if (!customElements.get('gs-col-ver-mas')) {
    class GsColVerMas extends HTMLElement {
      connectedCallback() {
        if (this._listo) return;
        this._listo = true;
        this.btn = this.querySelector('.gs-mas__btn');
        if (!this.btn) return;
        this.btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.cargar(0);
        });
        if (this.hasAttribute('data-auto')) {
          this.cargar(0);
          return;
        }
        // Pre-carga: cuando el botón está por entrar en pantalla se trae la tanda siguiente. Al tocar, las
        // tarjetas entran en el mismo momento del toque (antes llegaban ~700 ms después y empujaban el pie
        // que ya estaba a la vista: CLS 0,49). IntersectionObserver: sin medidas en el scroll.
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((en) => {
            if (en.some((x) => x.isIntersecting)) this.precargar();
          }, { rootMargin: '0px 0px 600px 0px' });
          this._io.observe(this);
        }
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }

      pedir(urlTxt) {
        const url = new URL(urlTxt, window.location.href);
        url.searchParams.set('section_id', this.dataset.section);
        return fetch(url.toString(), { credentials: 'same-origin' })
          .then((r) => {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return {
              nuevos: Array.from(doc.querySelectorAll('#ProductsList > .f-column')),
              sig: doc.querySelector('gs-col-ver-mas')
            };
          });
      }

      precargar() {
        if (this._pre || this._cargando) return;
        const pre = { url: this.dataset.url, listo: false };
        pre.p = this.pedir(pre.url);
        pre.p.then(
          () => { pre.listo = true; },
          () => { if (this._pre === pre) this._pre = null; }
        );
        this._pre = pre;
      }

      // Si la tanda todavía no llegó: lugares reservados del alto de una tarjeta, puestos en el mismo toque.
      // El salto queda dentro de la ventana del toque (no cuenta como CLS) y el pie ya está lejos cuando llegan.
      reservar(lista) {
        const n = Math.min(24, parseInt(this.dataset.restantes, 10) || 24);
        const modelo = lista.lastElementChild;
        const alto = modelo ? modelo.getBoundingClientRect().height : 0;
        const frag = document.createDocumentFragment();
        const esq = [];
        for (let i = 0; i < n; i++) {
          const d = document.createElement('div');
          d.className = 'f-column gs-mas__esq';
          d.setAttribute('aria-hidden', 'true');
          if (alto) d.style.height = alto + 'px';
          frag.appendChild(d);
          esq.push(d);
        }
        lista.appendChild(frag);
        return esq;
      }

      cargar(vueltas) {
        if (this._cargando) return;
        this._cargando = true;
        this.btn.setAttribute('aria-busy', 'true');
        const lista = document.getElementById('ProductsList');
        const pre = this._pre && this._pre.url === this.dataset.url ? this._pre : null;
        this._pre = null;
        const pedido = pre ? pre.p : this.pedir(this.dataset.url);
        const esq = lista && !(pre && pre.listo) ? this.reservar(lista) : [];

        pedido
          .then(({ nuevos, sig }) => {
            if (lista) {
              nuevos.forEach((n, i) => {
                if (esq[i]) lista.replaceChild(n, esq[i]);
                else lista.appendChild(n);
              });
            }
            esq.slice(nuevos.length).forEach((e) => e.remove());
            this._cargando = false;
            this.btn.removeAttribute('aria-busy');
            if (!sig) {
              if (this._io) this._io.disconnect();
              (this.closest('.gs-mas') || this).remove();
              return;
            }
            this.dataset.url = sig.dataset.url;
            this.dataset.restantes = sig.dataset.restantes || '';
            this.btn.setAttribute('href', sig.dataset.url);
            if (nuevos.length === 0 && vueltas < 3) {
              this.cargar(vueltas + 1);
              return;
            }
            // si el botón sigue cerca de la pantalla, que se vuelva a pre-cargar la tanda siguiente
            if (this._io) {
              this._io.unobserve(this);
              this._io.observe(this);
            }
          })
          .catch(() => {
            // Si falla el pedido, se va a la página siguiente entera: nunca queda un botón muerto
            esq.forEach((e) => e.remove());
            const u = new URL(this.dataset.url, window.location.href);
            window.location.href = u.toString();
          });
      }
    }
    customElements.define('gs-col-ver-mas', GsColVerMas);
  }

  if (window.__gsColOrden) return;
  window.__gsColOrden = true;

  // Pestaña del navegador con el título de la página ("Más vendidos – Ganga Shop" y no "Todos – Ganga Shop")
  function pestana() {
    const cab = document.getElementById('GsColCab');
    const h1 = cab && cab.querySelector('.gs-col-cab__titulo');
    const tienda = cab && cab.getAttribute('data-gs-tienda');
    if (!h1 || !tienda) return;
    const t = h1.textContent.trim();
    if (t) document.title = t + ' – ' + tienda;
  }
  pestana();

  const RE = ['GsColCab', 'GsColPrecio'];
  function clave(u) {
    const ruta = u.pathname.replace(/\/$/, '').toLowerCase();
    const sp = u.searchParams;
    const gte = parseFloat(sp.get('filter.v.price.gte')) || 0;
    const lte = parseFloat(sp.get('filter.v.price.lte')) || 0;
    const precio = gte > 0 || lte > 0;
    let k = ruta;
    if (/\/collections\/(todos|all)$/.test(ruta)) {
      if (precio) k += '|p:' + Math.round(gte * 100) + '-' + Math.round(lte * 100);
      else {
        const o = sp.get('sort_by');
        k += o === 'created-descending' ? '|nov' : o === 'best-selling' ? '|mv' : '|todos';
      }
    } else if (ruta.indexOf('/collections/') === 0) {
      k += precio ? '|precio' : '|';
    }
    if (ruta === '/search') k += '|q:' + (sp.get('q') || '').trim().toLowerCase();
    return k;
  }
  function chipActual() {
    const chips = document.querySelectorAll('.gs-chips__chip');
    if (!chips.length) return;
    const aca = clave(new URL(window.location.href));
    let marcado = false;
    chips.forEach((a) => {
      const href = a.getAttribute('href') || '';
      const es = !marcado && href.indexOf('#') === -1 && clave(new URL(href, window.location.href)) === aca;
      if (es) {
        marcado = true;
        a.setAttribute('aria-current', 'page');
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }
  function redibujar(datos) {
    if (!datos || !datos.responseText) return;
    const doc = new DOMParser().parseFromString(datos.responseText, 'text/html');
    RE.forEach((id) => {
      const aca = document.getElementById(id);
      const alla = doc.getElementById(id);
      if (aca && alla) aca.innerHTML = alla.innerHTML;
    });
    pestana();
    chipActual();
  }
  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, redibujar);
  }
  document.addEventListener('change', (e) => {
    const sel = e.target && e.target.closest ? e.target.closest('select[data-gs-orden]') : null;
    if (!sel) return;
    const caja = sel.closest('.gs-orden');
    const txt = caja ? caja.querySelector('[data-gs-orden-txt]') : null;
    if (txt && sel.selectedIndex > -1) txt.textContent = sel.options[sel.selectedIndex].text;
    if (!document.querySelector('form[is="facet-form"]')) {
      const u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });
})();
